export const SET_GTM_INIT = "google_tag_manager/SET_GTM_INIT";

export const setGTMInit = () => ({type: SET_GTM_INIT});
export const SET_GTM_INIT = "google_tag_manager/SET_GTM_INIT";

export const setGTMInit = () => ({type: SET_GTM_INIT});
